<div class="filter-container">
  <wlm-base-filter-container
    *ngIf="adaptersReady"
    class="filters"
    [provideAdapters]="provideAdapters"
    [keysToComplete]="keysToComplete"
    [clearAll$]="clearAll$"
    [apply$]="apply$"
    (filterResults)="processFilterChanges($event)"
    (applyResults)="onGlobalApplyResults($event)"
    (filterComplete)="onGlobalComplete()"
    (clearAll)="onClearAll()"
  >
    <wlm-base-filter
      (filterText)="onFilterText($event)"
      [settings]="networkElementsGroupSettings"
      [persistItems$]="persistFilters$"
    >
      <wlm-network-elements-filter-item
        [filterText]="filterText"
        [fieldName]="filterConfiguration.neSettings.elementTypeFieldName"
        [defaultSelectedElements]="filterConfiguration.defaultNETypeIds"
        [selectedIds]="filterConfiguration.neSettings?.selectedElementIds"
        [settings]="networkFilterItemSettings"
        [filterListElements]="filterListElements"
        [isGisEnabled]="isGisEnabled"
        [isAllNeTypesRequired]="isAllNeTypesRequired"
        (selectedItem)="onSelectedItem($event)"
        mode="single"
      ></wlm-network-elements-filter-item>
    </wlm-base-filter>
  </wlm-base-filter-container>
</div>
